import { ReactDiagram } from 'gojs-react';
import { Box, styled } from '@mui/material';
import { useStore } from '../../../stores/store';
import { observer } from 'mobx-react-lite';

type DiagramNode = {
    key: number;
    width: number;
    color: string;
    figure: string;
    loc?: string;
}

type DiagramLink = {
    from: number;
    to: number;
    color: string;
}

export type IDiagramValues = {
    key: number;
    text: string;
    loc?: string;
    strokeColor: DiagramNode['color'],
    containerWidth: DiagramNode['width'],
    width: DiagramNode['width']; 
    color: DiagramNode['color']; 
    figure: DiagramNode['figure']; 
    linkColor: DiagramLink['color'];
    parent?: number | number[];
}

interface Props {
    styles: {
        height: number
    }
}

const DiagramBox = styled(Box)(() => ({
    '.diagram-component': {
        width: '100%',
        height: '100%',
        border: 'solid 1px black',
        backgroundColor: '#8D8D8D',
        color: 'white',
    }
}))

function Diagram(props: Props) {
    const { diagramInit, nodeDataArray, linkDataArray } = useStore().rbdStore

    return (
        <DiagramBox height={props.styles.height}>
            <ReactDiagram
                initDiagram={diagramInit}
                divClassName='diagram-component'
                nodeDataArray={nodeDataArray}
                linkDataArray={linkDataArray}
            />
        </DiagramBox>
    );
}

export default observer(Diagram)
